import React from 'react'

export default function AddClassMaterial() {
    return (
        <div>
            <div id="card_body_new">
                    
            </div>
        </div>
    )
}
